import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import NewArticle from '../container-components/NewArticle'
import DetailedArticleType from '../container-components/DetailedArticleType'
import '../../index.css' 

//Component for dialogs 
const ModalComponent = ({ handleShow, handleClose, handleSubmit, reload, modalTitle, modalBody, formTitle, formDisabled = false, tabletView = false, isDraftModal = false, handleSave = null }) => {
    //console.log("ModalComponent init")
    if (tabletView == true) {
        //console.log("TabletView true")
        return (TabletModalComponent({ handleShow, handleClose, handleSubmit, reload, modalTitle, modalBody, formTitle }))
    } else {
        console.log("ModalComponent", formTitle)
        return (
            <Modal show={handleShow}
                onHide={handleClose} onExit={reload}
                backdrop="static" className="modal-biggerButtons" className={formTitle}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>

                <Modal.Body>{modalBody}</Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Abbrechen</Button>
                    {isDraftModal && <Button form={formTitle} type="submit" variant="secondary" onClick={handleSave}>Entwurf zwischenspeichern</Button>}
                    <Button form={formTitle} disabled={formDisabled} type="submit" variant="secondary" onClick={handleSubmit}>{isDraftModal ? "Lieferschein abschicken" : "Speichern"}</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

const TabletModalComponent = ({ handleShow, handleClose, handleSubmit, reload, modalTitle, modalBody, formTitle }) => {
    return (
        <Modal show={handleShow}
            onHide={handleClose} onExit={reload}
            backdrop="static" dialogClassName="tablet-modal">
            <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>

            <Modal.Body>{modalBody}</Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Abbrechen</Button>
                {/*<Button form={formTitle} type="submit" variant="secondary" onClick={handleSubmit}>Speichern</Button>*/}
            </Modal.Footer>
        </Modal>
    )
}

export { ModalComponent }